




import Vue from 'vue'
import ProfitCenterAdditionalFields from '@/components/additional-fields/ProfitCenterAdditionalFields.vue'

export default Vue.extend({
  name: 'ProfitCenterAdditionalFieldsPage',

  components: {
    ProfitCenterAdditionalFields
  },

  props: {
    profitCenterId: Number
  }

})
